import React from "react";

const PaymentMethodSelector = ({ selectedMethod, onSelectMethod }) => {
  const paymentMethods = [
    {
      id: "qrcode",
      name: "QR Code",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
          />
        </svg>
      ),
      description: "Pay via bank transfer using QR code",
      disable: false,
    },
    {
      id: "buymeacoffee",
      name: "Buy Me A Coffee",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
          />
        </svg>
      ),
      description: "Support us through Buy Me A Coffee platform",
      disable: true,
    },
    {
      id: "stripe",
      name: "Credit Card",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          />
        </svg>
      ),
      description: "Secure payment via credit card (Stripe)",
      disable: true,
    },
  ];

  return (
    <div className="w-full">
      <div className="flex flex-col md:flex-row gap-4">
        {paymentMethods.map((method) => (
          <button
            key={method.id}
            disabled={method.disable}
            onClick={() => onSelectMethod(method.id)}
            className={`flex-1 flex flex-col items-center p-4 rounded-lg border transition-colors ${
              selectedMethod === method.id
                ? "border-rose-700 bg-rose-50 text-rose-700"
                : "border-gray-200 hover:bg-gray-50 text-gray-700"
            }`}
          >
            <div
              className={`p-2 rounded-full mb-2 ${
                selectedMethod === method.id
                  ? "bg-rose-100"
                  : "bg-gray-100"
              }`}
            >
              {method.icon}
            </div>
            <h3 className="font-medium text-base">{method.name}</h3>
            <p className="text-xs text-center mt-1">{method.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
